import { SET_PAGE_TITLE, SET_PAGE_SUB_TITLE } from './types';
import { SIGN_OUT } from '../auth/types';

let initialState = {
  pageTitle: 'People',
  pageSubTitle: ''
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_OUT:
      return {
        ...initialState
      };
    case SET_PAGE_TITLE:
      return {
        ...state,
        pageTitle: action.title
      };
    case SET_PAGE_SUB_TITLE:
      return {
        ...state,
        pageSubTitle: action.subtitle
      };
    default:
      return state;
  }
};
